<template>
  <div>
    <!-- 打印标签 -->
    <el-dialog
      :visible="visible"
      @close="closeVisible"
      :close-on-click-modal="false"
      width="800px"
      title="打印标签"
    >
      <div style="position: relative">
        <div id="printView">
          <div class="printBoxSeat clearfix" v-for="(item, index) in printArr" :key="index">
            <p class="siteNum">{{item.name}}</p>
            <p class="qrcode">
              <img :src="item.img" style="width: 100%" alt="failed" />
            </p>
          </div>
        </div>
        <div style="position: absolute; top:0; right:0">
          <p
            style="display:inline;font-weight:bold;font-size:16px;padding-right:10px;"
          >共{{printArr.length}}个标签</p>
          <el-button type="primary" size="small" v-print="'#printView'">打印</el-button>
          <el-button type="info" size="small" @click="closeVisible">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'print',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    printArr: {
      type: Array,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {
    closeVisible() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.printBoxSeat {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 48mm;
  height: 19.0mm;
  // padding: 0.3mm 0;
  border: 0.2mm solid rgb(0, 0, 0);
  // margin-top: 1mm;
  margin-bottom: 0.96mm;

  >p{
    margin: 0;
    padding: 0;
    display: flex;
    justify-content:center;
    align-items:center;
  }
  .siteNum {
    padding-right: 0.2mm;
    font-size: 18px;
    font-weight: bold;
    flex:1;
  }
  .qrcode {
    overflow: hidden;
    width: 17.4mm;
    border-left: 0.2mm solid rgb(0, 0, 0);
    >img{
    height: 17.4mm;
    }
  }
  }
</style>
